import { Types } from "../actions/MachineMaintenanceSummaryListPlannedActions";

const initialState = {
    areaGroupListPlanned: {},
    mainEquipmentListPlanned: {},
    subEquipmentListPlanned: {},
    subEquipmentsTaskListPlanned: {},
    maintenanceTypes: [],
    poolList:{}
};

export const MachineMaintenanceSummaryListPlannedReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_AREA_GROUP_LIST_PLANNED:
            return {
                ...state,
                areaGroupListPlanned: action.payload || state.areaGroupListPlanned,
            };
        case Types.SET_MAIN_EQUIPMENT_LIST_PLANNED:
            return {
                ...state,
                mainEquipmentListPlanned: action.payload || state.mainEquipmentListPlanned,
            };
        case Types.SET_SUB_EQUIPMENT_LIST_PLANNED:
            return {
                ...state,
                subEquipmentListPlanned: action.payload || state.subEquipmentListPlanned,
            };
        case Types.SET_SUB_EQUIPMENTS_TASK_LIST_PLANNED:
            return {
                ...state,
                subEquipmentsTaskListPlanned: action.payload || state.subEquipmentsTaskListPlanned,
            };
        case Types.SET_MAINTENANCE_TYPE_DATA:
            return {
                ...state,
                maintenanceTypes: action.payload || state.maintenanceTypes,
            };
        case Types.SET_POOL_DATA:
                return {
                    ...state,
                    poolList: action.payload || state.poolList,
                };
        default:
            return state;
    }
}